module.exports = __webpack_public_path__ + "img/server_error.d217f9a0.png";